import styled from "@emotion/styled";

export const HostContainer = styled.div`
  position: relative;
`;
